// extracted by mini-css-extract-plugin
export default {"header":"new-dispatch-header_header__CgQuU","title":"new-dispatch-header_title__NKJA8","buttons":"new-dispatch-header_buttons__JTIXd"};